<template>
  <div>
    <el-form ref="form" :rules="rules" :model="form" label-width="150px">
      <div class="integra-title">
        {{ form.title }}
      </div>

      <el-form-item :label="$t('message.table.isEnabled')">
        <el-switch v-model="form.enabled" />
      </el-form-item>

      <div>

        <el-form-item :label="$t('message.title.AppId')" prop="appId">
          <el-input type="number" v-model="form.appId"></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.title.CorpId')" prop="corpId">
          <el-input v-model="form.corpId"></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.title.CorpSecret')" prop="corpSecret">
          <el-input v-model="form.corpSecret"></el-input>
        </el-form-item>
      </div>
      <div style="display: flex; margin-top: 68px;">
        <el-button style="margin-left: auto;" size="mini" type="primary" @click="submit"> {{ $t('message.button.submit')
          }}</el-button>
        <el-button size="mini" @click="reset"> {{ $t('message.button.reset') }}</el-button>
      </div>
    </el-form>

  </div>
</template>

<script>
export default {

  data() {
    return {
      editable: true,
      form: {
        title: '',
        hostname: '',
        name: '',
        password: '',
        checked: false,
      },
      rules: {
        appId: {
          required: true, message: this.$t("message.warning.required"), trigger: 'blur'
        },
        corpId: { required: true, message: this.$t("message.warning.required"), trigger: 'blur' },
        corpSecret: { required: true, message: this.$t("message.warning.required"), trigger: 'blur' }
      }
    }
  },
  props: ['data'],
  methods: {

    reset() {
      const obj = {
        enabled: false,
        appId: '',
        corpId: '',
        corpSecret: ''
      }
      this.form = { ...this.form, ...obj }
    },

    deleteItem() {
      this.$emit('delete')
    },

    submit() {
      // return this.form
      this.$refs.form.validate((valid) => {
        if (valid) {
          // return this.form
          this.$emit('submit', this.form)
        } else {
          this.$message.error(this.$t('message.error.save'));
          return false;
        }
      })
    },

  },
  watch: {
    data(val) {
      const enabled = !!val.actived;
      this.form = { ...val, enabled }
    }
  },
  mounted() {
    const enabled = !!this.data.actived;
    this.form = { ...this.data, enabled }
  }

}
</script>

<style scoped>
.delete {
  cursor: pointer;
}

.delete:hover {
  color: #409EFF;
}

.integra-title {
  font-size: 14px;
  font-weight: 600;
  padding-left: 25px;
  padding-bottom: 10px;
  margin: 10px 0;
  border-bottom: 1px solid #DCDFE6;
  flex: 1
}

.integra-title ::v-deep .el-input__inner {
  width: 80%;
  font-size: 16px;
  font-weight: 600;
  border-radius: 0px;
  border-width: 0;
  border-bottom-width: 1px;
  padding: 3px;
  /*outline: medium;*/
}

.integra-delete {
  flex: 0 20px;
  padding: 12px 0;
}
</style>
